import { categoriesTree } from "@/static/categories-tree.js"

import { API_URL_CATALOG } from "./urls"

// GET requests

const getCategoriesApi = async () =>
  window.axios
    .get(API_URL_CATALOG + "product/category/all/v1/get")

    .then(({ data }) => {
      if (data.code === "OC_OK") {
        const categories = data.createdEntity.listOfProductCategory.map((category: any) => {
          const categorySubCategories = categoriesTree[category.code as keyof typeof categoriesTree]

          return {
            ...category,
            subCategories: category.productCategoryChildList.filter((subCategory: any) =>
              categorySubCategories?.includes(subCategory.code),
            ),
          }
        })

        return categories.map((category: any) => ({
          ...category,
          subCategories: category.subCategories.map((category: any) => ({
            ...category,
            abstractProductList: category.abstractProducts.map((product: any) => ({
              ...product,
              name: product.abstractProductShortName,
              code: product.abstractProductCode,
            })),
          })),
        }))
      }

      throw new Error(data.message)
    })

    .catch((error) => {
      throw error
    })

export { getCategoriesApi }
